import React from 'react';
const SvgPin: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 13v0a3 3 0 01-3-3v0a3 3 0 013-3v0a3 3 0 013 3v0a3 3 0 01-3 3z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 21s-7-5.75-7-11a7 7 0 1114 0c0 5.25-7 11-7 11z"
      />
    </svg>
  );
};
export default SvgPin;
